// Vendors
import { apiUtils } from '@openbank/cf-ui-architecture-core';
// Constants
import { ONBOARDING_ACCESS_AUTHORIZATION_ENDPOINT } from './constants/token.service.constants';
import { CUSTOM_BANK_ID } from 'constants/api.constants';
// Types
import { TokenApiDataApiResponseType } from '../types/token-api-data-api-response.type';

const fetchCustomerAuthorizationDataService = async (
  token: string
): Promise<[TokenApiDataApiResponseType, Response]> =>
  apiUtils.get({
    ...ONBOARDING_ACCESS_AUTHORIZATION_ENDPOINT,
    authHeaders: false,
    customHeaders: { accessToken: token, ...CUSTOM_BANK_ID },
  });

export { fetchCustomerAuthorizationDataService };
